<template>
    <div>
        <dt-modal :modalVisible="editModalVisible" :isCustomFooter="true" :title="'修改密码'" :modalWidth="500">
            <template slot="customSlot">
                <div class="tipsText" v-if="showSimpleTip">
                    <span>检测到当前密码过于简单，请重新设置密码</span>
                </div>
                <Form ref="editPasswordForm" :model="editPasswordForm" :label-width="100" label-position="right"
                    :rules="passwordValidate">
                    <FormItem label="新密码" prop="newPass">
                        <Input :type="passwordType" v-model="editPasswordForm.newPass"
                            :icon="passwordType == 'password' ? 'eye' : 'eye-disabled'" placeholder="请输入新密码"
                            @on-click="setPasswordType" style="width: 300px">
                        </Input>
                    </FormItem>
                    <FormItem label="确认新密码" prop="rePass">
                        <Input :type="passwordConfirmType" v-model="editPasswordForm.rePass"
                            :icon="passwordConfirmType == 'password' ? 'eye' : 'eye-disabled'"
                            @on-click="setConfirmPass" placeholder="请再次输入新密码" style="width: 300px"></Input>
                    </FormItem>
                </Form>
            </template>
            <template slot="customFooterSlot">
                <Button @click="cancel" v-if="showCloseBtn">取消</Button>
                <Button type="primary" @click="saveEditPass" :loading="sureBtnLoading">确认
                </Button>
                <Button @click="logout" v-if="showExitBtn">退出登录</Button>
            </template>
        </dt-modal>
    </div>
</template>

<script>
import { editUserPassWord, insertCommonCatch } from "@/service/api";
import { validatePassword } from "@/library/js/validate.js";
import { removeToken, removeUserId } from "@/library/js/auth.js";

const dtModal = () => import("@/components/ddtModal");
export default {
    name: "edit-password",
    props:
    {
        editModalVisible: {
            type: Boolean,
            default: false
        },
        showSimpleTip: {
            type: Boolean,
            default: true
        },
        showExitBtn: {
            type: Boolean,
            default: true
        },
        showCloseBtn: {
            type: Boolean,
            default: false
        }
    },
    components: {
        dtModal,
    },
    data() {
        return {
            savePassLoading: false,
            editPasswordForm: {
                oldPass: "",
                newPass: "",
                rePass: "",
            },
            passwordValidate: {
                newPass: [
                    { required: true, message: "请输入新密码", trigger: "blur" },
                    // { validator: validatePassword, trigger: "blur" },
                ],
                rePass: [
                    { required: true, message: "请再次输入新密码", trigger: "blur" },
                ],
            },
            passwordType: "password",
            passwordConfirmType: "password",
            sureBtnLoading: false,
        };
    },
    methods: {
        cancelEditPass() {
            //初始化表单
            this.$refs["editPasswordForm"].resetFields();
            this.editPasswordForm.oldPass = "";
            this.editPasswordForm.newPass = "";
            this.editPasswordForm.rePass = "";
        },
        saveEditPass() {
            let _this = this;
            _this.$refs["editPasswordForm"].validate((valid) => {
                if (valid) {
                    if (
                        _this.editPasswordForm.rePass !== _this.editPasswordForm.newPass
                    ) {
                        _this.$Message.error("两次输入密码不一致");
                        return;
                    }
                    _this.savePassLoading = true;
                    // 修改密码 并且更新弱密码的状态
                    let params = {
                        userId: _this.$store.getters.userId,
                        oldPassWord: _this.editPasswordForm.oldPass,
                        newPassWord: _this.editPasswordForm.newPass,
                    };
                    editUserPassWord(params)
                        .then(function (result) {
                            _this.savePassLoading = false;
                            if (result && parseInt(result.code) === 1) {
                                _this.$Message.success("修改成功");
                                if (_this.showCloseBtn) {
                                    _this.cancel();
                                } else {
                                    _this.$store.commit("user/SET_WEAKPASSWORD", false);
                                }
                            } else {
                                _this.$Message.error(result.msg);
                            }
                        })
                        .catch(function (error) {
                            _this.savePassLoading = false;
                            _this.$Message.error(error.msg);
                        });
                }
            });
        },
        cancel() {
            this.cancelEditPass();
            this.$emit("close-modal");
        },

        /**
         * 退出
         */
        logout() {
            let _this = this;
            _this.$Modal.confirm({
                title: "提示",
                content: "<p>确认退出吗?</p>",
                onOk: () => {
                    //清除所有cookie
                    removeToken();
                    removeUserId();
                    _this.$store.dispatch("menu/setSelectedMenuId", "");
                    ssoClient.logout();
                },
            });
        },

        /**
         * 设置密码显示是密文还是明文
         */
        setPasswordType() {
            if (this.passwordType == "password") this.passwordType = "text";
            else this.passwordType = "password";
        },
        /**
         * 设置确认密码显示是密文还是明文
         */
        setConfirmPass() {
            if (this.passwordConfirmType == "password")
                this.passwordConfirmType = "text";
            else this.passwordConfirmType = "password";
        }
    }
};
</script>

<style lang="scss" scoped>
.tipsText {
    text-align: center;
    margin-top: 10px;
    margin-bottom: 25px;
    font: bold 15px "幼圆";
}
</style>
